import React, { Fragment, useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Label,
  Form,
  Media,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Col,
} from "reactstrap";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import SweetAlert from "sweetalert2";
import { Add } from "../../../Constant";
import { toast } from "react-toastify";
import { H3, Breadcrumbs, H4 } from "../../../AbstractElements";
import { getDataWithToken, postDataWithToken } from "../../../Utils/restUtils";
import SearchList from "../../../CommonElements/Search";
import Transparentspinner from "../../Common/loader/Transparentspinner";
import IndustryFilter from "../../Common/Filters/IndustryFilter";
import {
  getCompanyModule,
  deleteCompanyModule,
  changeCompanyModuleStatus,
} from "../../../CommonURL";

const UserModuleTable = () => {
  const [companyModulesData, setCompanyModulesData] = useState([]);
  const [companyModulesList, setCompanyModulesList] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [tempSearch, setTempSearch] = useState("");
  const [isIndustry, setIsIndustry] = useState("");
  const [tempIndustry, setTempIndustry] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const navigate = useNavigate();

  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };

  useEffect(() => {
    getCompanyModulesData(1);
  }, []);

  const companyModuleColumns = [
    {
      name: <H4 attrH4={{ className: "mb-0" }}>Sl No</H4>,
      selector: (row) => row.Si,
      sortable: true,
      width: "70px",
      center: true,
    },
    {
      name: <i className="fa fa-gears" style={{ fontSize: "15px" }}></i>,
      selector: (row) => row.action,
      cell: (row) => <ActionCell row={row} />,
      width: "60px",
      center: true,
    },
    {
      name: <H4 attrH4={{ className: "mb-0" }}>Company Name</H4>,
      selector: (row) => row.companyName,
      sortable: true,
      wrap: true,
      grow: 2,
      minWidth: "180px",
    },
    {
      name: <H4 attrH4={{ className: "mb-0" }}>Module Name</H4>,
      selector: (row) => row.moduleName,
      sortable: true,
      wrap: true,
      grow: 2,
      minWidth: "180px",
    },
    {
      name: <H4 attrH4={{ className: "mb-0" }}>Industry Type</H4>,
      selector: (row) => row.industryTypeName,
      sortable: true,
      wrap: true,
      grow: 2,
      minWidth: "180px",
    },
    {
      name: <H4 attrH4={{ className: "mb-0" }}>Status</H4>,
      selector: (row) => row.status,
      cell: (row) => (
        <Media body className={`flex-grow-1 text-end icon-state`}>
          <Label className="switch">
            <Input
              type="checkbox"
              defaultChecked={row.status === "active"}
              onChange={(event) => handleSwitchToggle(event, row.id)}
            />
            <span className="switch-state"></span>
          </Label>
        </Media>
      ),
      sortable: false,
      width: "120px",
      center: true,
    },
  ];

  const getCompanyModulesData = async (
    page = currentPage,
    size = perPage,
    search = searchKeyword,
    industry_id = isIndustry?.value || "",
  ) => {
    setLoading(true);

    try {
      const response = await getDataWithToken(
        getCompanyModule +
          `?page=${page}&page_length=${size}&search=${search}&industry_type_id=${industry_id}`
      );

      let serialNo = (page - 1) * size + 1;
      const list =
        response?.data?.data ||
        response?.data ||
        (Array.isArray(response) ? response : []) ||
        [];
      const total = response?.data?.total ?? response?.total ?? list.length;

      setCompanyModulesList(list);
      setTotalRows(total);

      setCompanyModulesData(
        list.map((e, index) => ({
          Si: serialNo + index,
          id: e.id || e.company_module_id,
          companyId: e.company_id || e.user_id,
          moduleId: e.module_id,
          industryTypeId: e.industry_type_id,
          companyName: e.company_name || e.user_name || e.name || "-",
          moduleName: e.module_name || "-",
          industryTypeName: e.industry_type_name || "-",
          status: e.status || "-",
          createdAt: e.created_at || "-",
        }))
      );
    } catch (error) {
      console.error("Error fetching company modules:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = () => {
    setCurrentPage(1);
    setSearchKeyword(tempSearch);
    setIsIndustry(tempIndustry);
    getCompanyModulesData(1, perPage, tempSearch, tempIndustry?.value || "");
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getCompanyModulesData(page, perPage, searchKeyword, isIndustry?.value || "");
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    getCompanyModulesData(page, newPerPage, searchKeyword, isIndustry?.value || "");
  };

  const updateSearchKeyword = (keyword) => {
    setTempSearch(keyword);
  };

  const handleSwitchToggle = async (event, itemId) => {
    const checked = event.target.checked;
    setLoading(true);
    try {
      const response = await postDataWithToken(changeCompanyModuleStatus, {
        company_module_id: itemId,
        user_module_id: itemId,
        status: checked ? "active" : "inactive",
      });
      toast.success(response?.data?.message || response?.message || "Status updated");
      await getCompanyModulesData(currentPage);
    } catch (err) {
      toast.error("Failed to update status.");
    } finally {
      setLoading(false);
    }
  };

  const deleteCompanyModulesList = async (moduleId) => {
    SweetAlert.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this Company Module!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          await postDataWithToken(
            `${deleteCompanyModule}?company_module_id=${moduleId}`,
            { company_module_id: moduleId }
          );
          SweetAlert.fire("Deleted!", "Company Module has been deleted.", "success");
          await getCompanyModulesData(currentPage);
        } catch (err) {
          toast.error("Failed to delete company module.");
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const redirectToEditForm = (data) => {
    const editFormURL = `${process.env.PUBLIC_URL}/configuration/company-modules-edit?id=${data.id}`;
    navigate(editFormURL);
  };

  const ActionCell = ({ row }) => {
    const [dropdownOpen, setDropdownOpen] = React.useState(false);
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    return (
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
        <DropdownToggle
          color="#00000"
          style={{ fontSize: "14px", zIndex: 1000 }}
        >
          <i className="fa fa-ellipsis-v"></i>
        </DropdownToggle>
        <DropdownMenu container="body">
          <DropdownItem
            style={toggleStyle}
            onClick={() => redirectToEditForm(row)}
          >
            Edit
          </DropdownItem>
          <DropdownItem
            style={{
              padding: "10px 20px",
              color: "red",
              opacity: "0.8",
              fontSize: "14px",
              margin: "0",
            }}
            onClick={() => deleteCompanyModulesList(row.id)}
          >
            Delete
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  };

  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <Breadcrumbs
        mainTitle="Company Module"
        parent="Configuration"
        title="Company Module"
      />
      <Card>
        <CardHeader
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <H3>Company Module List</H3>
          <div>
            <Link
              to={`${process.env.PUBLIC_URL}/configuration/company-modules-add`}
              className="btn btn-primary"
            >
              {Add}
            </Link>
          </div>
        </CardHeader>
        <Form
          className="px-4 pb-2"
          onSubmit={(e) => {
            e.preventDefault();
            handleFilter();
          }}
        >
          <Row className="g-3 align-items-center ">
            <Col sm="12" md="5" lg="3" className="pt-3">
              <SearchList
                updateSearchKeyword={updateSearchKeyword}
                onEnter={handleFilter}
              />
            </Col>

            <Col sm="12" md="6" lg="3">
              <IndustryFilter
                IsIndustry={tempIndustry}
                setIsIndustry={setTempIndustry}
              />
            </Col>

            <Col sm="12" md="6" lg="3">
              <button type="submit" className="btn btn-primary">
                Filter
              </button>
            </Col>
          </Row>
        </Form>

        <CardBody>
          <div className="order-history table-responsive">
            <DataTable
              columns={companyModuleColumns}
              data={companyModulesData}
              pagination
              paginationServer
              defaultSortAsc
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default UserModuleTable;
